import { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { StoreStatusSchema, StoreUpdateStatusRequestSchema } from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

// UpdateStoreStatusRequest::prepareForValidation
const normalize = fieldNormalizer({
  enums: [{ field: 'status', options: StoreStatusSchema.options }]
})

const schema = StoreUpdateStatusRequestSchema.strict()

export const StoreUpdateStatus = (_context: NoContext): z.ZodType<z.output<typeof schema>> =>
  z.preprocess(normalize, schema)
